/**
 *
 * @returns {'eligibility' | 'qualify' | 'qualify-oneclick' | 'qualify-subone' | 'getting-started' | 'getting-started-v2' | 'getting-started-v3' | 'savings-estimates' | 'sub-one-new-stack' | 'unknown' | 'savings-estimates-static' | 'savings-estimates-static-variant-a' | 'savings-estimates-static-variant-b' | 'savings-estimates-static-variant-c' | 'savings-estimates-btf-v1' | 'savings-estimates-btf-v2' | 'savings-estimates-btf-v3' | 'savings-estimates-btf-v4' | 'savings-estimates-c1' | 'co-savings-estimates-b' | 'co-savings-estimates-c' | 'ps-softpull' | 'onboarding' | 'onboarding-alt' | 'onboarding-savings' | 'onboarding-savings-v2' | 'onboarding-savings-v3' | 'explore-options'}
 */
export function getFunnelFromUrl() {
  const url = window.location.href
  if (/\/explore-options/i.test(url)) {
    return 'explore-options'
  }
  if (/eligibility/.test(url)) {
    return 'eligibility'
  }

  if (/qualify\/one-click/.test(url)) {
    return 'qualify-oneclick'
  }

  if (/qualify\/sub-one/.test(url)) {
    return 'qualify-subone'
  }

  if (/qualify/.test(url)) {
    return 'qualify'
  }

  if (/\/savings-estimates\/submit-btf-v1/i.test(url)) {
    return 'savings-estimates-btf-v1'
  }

  if (/\/savings-estimates\/submit-btf-v2/i.test(url)) {
    return 'savings-estimates-btf-v2'
  }

  if (/\/savings-estimates\/submit-btf-v3/i.test(url)) {
    return 'savings-estimates-btf-v3'
  }

  if (/\/savings-estimates\/submit-btf-v4/i.test(url)) {
    return 'savings-estimates-btf-v4'
  }

  if (/\/savings-estimates\/submit/i.test(url)) {
    return 'savings-estimates-static'
  }

  if (/\/savings-estimates-a\/submit/i.test(url)) {
    return 'savings-estimates-static-variant-a'
  }

  if (/\/savings-estimates-b\/submit/i.test(url)) {
    return 'savings-estimates-static-variant-b'
  }

  if (/\/savings-estimates-c\/submit/i.test(url)) {
    return 'savings-estimates-static-variant-c'
  }

  if (/\/co-savings-estimates-b\/submit/i.test(url)) {
    return 'co-savings-estimates-b'
  }

  if (/\/co-savings-estimates-c\/submit/i.test(url)) {
    return 'co-savings-estimates-c'
  }

  if (/\/savings-estimates-c1\/submit/i.test(url)) {
    return 'savings-estimates-c1'
  }

  if (/\/savings-estimates/i.test(url)) {
    return 'savings-estimates'
  }

  if (/\/sub-one/i.test(url)) {
    return 'sub-one-new-stack'
  }

  if (/\/personalized-savings/i.test(url)) {
    return 'ps-softpull'
  }

  if (/\/onboarding\/alt/i.test(url)) {
    return 'onboarding-alt'
  }

  if (/\/onboarding\/savings-v2/i.test(url)) {
    return 'onboarding-savings-v2'
  }

  if (/\/onboarding\/savings-v3/i.test(url)) {
    return 'onboarding-savings-v3'
  }

  if (/\/onboarding\/savings/i.test(url)) {
    return 'onboarding-savings'
  }

  if (/\/onboarding/i.test(url)) {
    return 'onboarding'
  }

  if (/\/getting-started\/v2/i.test(url)) {
    return 'getting-started-v2'
  }

  if (/\/getting-started\/v3/i.test(url)) {
    return 'getting-started-v3'
  }

  if (/\/getting-started/i.test(url)) {
    return 'getting-started'
  }

  return 'unknown'
}
